import { z } from 'zod';
export const clockMethodSchema = z.enum(['dialpad', 'slider']);
export const geoLocationSchema = z.object({
    ip: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    country: z.string().max(2).optional(),
    city: z.string().max(100).optional(),
});
export const validateLocationSchema = z.object({
    locationCode: z
        .string()
        .length(5)
        .regex(/^\d+$/, 'Location code must be 5 digits'),
});
export const clockActionSchema = z.object({
    employeeCode: z
        .string()
        .min(4)
        .max(10)
        .regex(/^\d+$/, 'Employee code must be numeric'),
    method: clockMethodSchema,
    geoLocation: geoLocationSchema.optional(),
    // Additional fields for backend clock action
    workspaceId: z.string().uuid().optional(),
    pin: z.string().min(4).max(10).optional(),
    action: z.enum(['clock_in', 'clock_out']).optional(),
    location: z.string().max(500).optional(),
});
export const updateTimesheetEntrySchema = z.object({
    clockIn: z.coerce.date().optional(),
    clockOut: z.coerce.date().optional().nullable(),
    breakMinutes: z.number().min(0).max(480).optional(),
    notes: z.string().max(1000).optional().nullable(),
    isFlagged: z.boolean().optional(),
    flagReason: z.string().max(500).optional().nullable(),
});
export const timesheetFilterSchema = z.object({
    locationId: z.string().uuid().optional(),
    employeeId: z.string().uuid().optional(),
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
    isFlagged: z.boolean().optional(),
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
});
//# sourceMappingURL=timesheet.js.map